import React, {Component} from "react";
import {Grid, Group, Image, Loader, Paper, Stack, Text, Button, ScrollArea,Overlay} from '@mantine/core'
import CustomHeader from "../components/CustomHeader";
import {IconCheck, IconSquare, IconSquareCheck} from "@tabler/icons";
import {socket} from "../components/Socket";
import {useLocation, useNavigate} from "react-router-dom";
import {getUserDetails} from "../RequestManager";
import CustomToast from "../components/CustomToast";
import {useViewportSize} from "@mantine/hooks";

class ChoosePlans extends Component{
    constructor(props) {
        super(props);
        this.state={
            id: this.props?.params?.id,
            isLoading: true,
            selected: [],
            bundlePlans: 0,
            coachingPlans: 0,
            lgPlans: 0,
            isAdding: false,
            products: [],
            planCount: 0,
        }
      }
    handleSelect = (id) =>{
        const {selected,planCount} = this.state;
        let cur = selected;
        if(selected.includes(id)){
            cur = cur.filter(a => a!= id)
        }else if(selected.length < planCount){
            cur.push(id)
        }
        this.setState({selected: cur})
    }
    componentDidMount() {
        this.getDetails();
        socket.on('success',this.handleSuccess);
        socket.on('failure',this.handleFailure);
    }
    componentWillUnmount() {
        socket.off('success');
        socket.off('failure');
    }
    getDetails = () =>{
        this.setState({isLoading: true});
        console.log('calling get Details');
        socket.emit('UserProfile',{mobile: this.props.mobile});
        socket.emit('ProductList',{id: this.state.id});
    }
    handleSuccess = (data) =>{
        switch(data?.type){
            case 'UserProfile':
                const {bundlePlans,coachingPlans,lgPlans} = data?.details || {bundlePlans: 0,coachingPlans: 0};
                if(bundlePlans === 0 && lgPlans === 0){
                    this.props.navigation('/')
                }else{
                    this.setState({details:data?.details,bundlePlans,lgPlans,coachingPlans,planCount: this.state?.id === 'LifeGrowth365' ? lgPlans : bundlePlans});
                }
                break;
            case 'ProductList':
                this.setState({products: data?.products,isLoading: false});
                break;
            case 'DashboardCreatePlan':
                this.setState({isAdding: false});
                this.props.navigation('/');
                break;
        }
    }
    handleFailure = (data) =>{}
    hideSnackbar = () =>{
        this.setState({alert: undefined});
    }
    handleProductsChoose = () =>{
        const {selected,id} = this.state;
        this.setState({isAdding: true});
        socket.emit('DashboardCreatePlan',{mobile: this.props?.mobile,products: selected,id});
    }
    render() {
        const {isLoading,selected,bundlePlans,coachingPlans,alert,isAdding,products,planCount} = this.state;
        return <div>
            <CustomHeader showBackPress={true} />
            <div style={{marginTop: 60, width: '100%'}}>
                {isLoading ? <Group position={'center'}><Loader color={'#075E54'}/></Group> : <div style={{marginTop: 60, width: '100%'}}>
                    {alert && <CustomToast alert={alert} onHide={this.hideSnackbar} />}
                    <Paper shadow={'md'} p={5}>
                        <Grid>
                            <Grid.Col span={10}>
                                <Stack sx={{gap: 3}} align={'center'}>
                                    <Group sx={{gap: 3}}>
                                        <Text size={20} weight={'bold'}>Selected Products: {selected.length} / {planCount}</Text>
                                        <Text color={'grey'} italic  weight={'bold'}>{coachingPlans > 0 ? `+ ( 1 Coaching Program ) `:""}</Text>
                                    </Group>

                                    <Text size={16} color={'dimmed'}>Please Select {planCount} Products</Text>
                                </Stack>
                            </Grid.Col>
                            <Grid.Col span={2}>
                                <Group position={'right'}>
                                    <Button variant={'outline'} loading={isAdding} disabled={selected.length < planCount} onClick={this.handleProductsChoose}>Update Plans</Button>
                                </Group>
                            </Grid.Col>
                        </Grid>
                    </Paper>
                    <ScrollArea style={{height: this.props.height - 150}}>
                        {/*{coachingPlans > 0 && <Grid m={10}>*/}
                        {/*    <ProductCard hideClick={true} bundlePlans={bundlePlans} isSelected={true}*/}
                        {/*                 product={this.diamondPlan} selected={selected}/>*/}
                        {/*</Grid>}*/}
                        <Grid m={10}>
                            {products.map(a => <ProductCard handleSelect={this.handleSelect} bundlePlans={planCount} isSelected={selected.includes(a?.id)} product={a} selected={selected} />)}
                        </Grid>
                    </ScrollArea>
                </div>}
            </div>
        </div>
    }
}

export default function(props){
    const navigation = useNavigate();
    const {state} = useLocation();
    const user = getUserDetails();
    console.log(user);
    const {height,width} = useViewportSize();
    return <ChoosePlans {...props} params={state} navigation={navigation} mobile={user?.mobile} user={user} height={height} width={width}  />
};

const ProductCard = ({isSelected,selected,bundlePlans, product,hideClick,handleSelect}) =>{
    const onSelect = () =>{
        if(!hideClick) handleSelect(product?.id)
    }
    return <Grid.Col span={12} lg={4} xl={4} md={6} >
        <Paper shadow={'md'} radius={10} onClick={onSelect} sx={{borderStyle: 'solid',borderWidth: 1, borderColor:isSelected ? 'green': '#ccc'}}>
            <Group sx={{gap: 5,opacity: selected.length >= bundlePlans && !isSelected ? 0.5 : 1}}>
                <Group position={'center'}>
                    {isSelected ? <IconSquareCheck size={35} /> : <IconSquare size={35} />}
                </Group>
                {product?.image && <Image src={product?.image} fit={'contain'}  height={80} width={80} radius={10} alt="img"/>}
                <Stack spacing={2}  sx={{flex: 1, flexDirection:'column'}}>
                    <Text size='md' weight={500} style={{color:'steelblue'}} align={'left'}>{product?.title}</Text>
                    <Text size='sm' color={'dimmed'} align={'left'}>{product?.content}</Text>
                </Stack>
            </Group>
        </Paper>
    </Grid.Col>
}
